module.exports = __webpack_public_path__ + "static/deploy-icon-03e42c0b97ecbd048b7f9ec059107f49.png";